import { Box } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

export const GradientSpinner = () => {
  const spinAnimation = keyframes`
	from {
		transform:rotate(0deg);
	}
	to {
		transform:rotate(360deg);
	}`;

  return (
    <Box
      boxShadow=" 0px 13.3333px 20px -6.66667px #D52FFF, inset 0px 0px 30px rgba(255, 255, 255, 0.82)"
      // boxShadow="0px 8px 12px -4px #E88AFF, inset 0px 0px 18px rgba(255, 255, 255, 0.82)"
      borderRadius="full"
      w="42px"
      h="42px"
    >
      <Box
        w="42px"
        h="42px"
        mixBlendMode="multiply"
        borderRadius="full"
        animation={`${spinAnimation} 1.2s linear infinite`}
        overflow="hidden"
        bg="radial-gradient(42.61% 55.51% at 60.46% 100%, rgba(255, 255, 255, 0.21) 0%, rgba(255, 255, 255, 0) 100%) , radial-gradient(58.56% 126.24% at 31.37% 0%, rgba(255, 255, 255, 0.46) 0%, rgba(255, 255, 255, 0) 77.6%) , radial-gradient(74.14% 74.14% at 102.47% 39.73%, #9E00FF 0%, rgba(158, 0, 255, 0.34) 77.6%) , radial-gradient(88.4% 88.4% at 86.12% 6.46%, #FF1C89 0%, rgba(229, 102, 163, 0) 56.56%) , radial-gradient(124.52% 124.52% at -3.99% 35.36%, #0066FF 0%, rgba(0, 78, 255, 0) 69.33%) , #FF00C7"
      />
    </Box>
  );
};
